import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  inject,
} from '@angular/core';
import { NgClass } from '@angular/common';

import { AttributeService, Product, TranslateDirective } from '@speedy/core';

@Component({
  selector: 'speedy-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateDirective, NgClass],
})
export class ProductDescriptionComponent implements AfterViewInit {
  @Input() product!: Product;

  @ViewChild('descriptionRef') descriptionRef: ElementRef<HTMLElement> | undefined;

  private readonly attributeService = inject(AttributeService);
  private readonly cdr = inject(ChangeDetectorRef);

  isSpecificationCollapsed = true;
  isDimensionsCollapsed = true;
  isShowMore = false;
  isShowMoreButtonVisible = false;

  readonly dimensionsLabels: Record<string, string> = {
    width: this.getAttributeLabel('width'),
    height: this.getAttributeLabel('height'),
    depth: this.getAttributeLabel('depth'),
    weight: this.getAttributeLabel('weight'),
    length: this.getAttributeLabel('length'),
    parcel_s: this.getAttributeLabel('parcel_s'),
  };

  ngAfterViewInit(): void {
    this.isShowMoreButtonVisible = this.isDescriptionOverflowing();
    this.cdr.detectChanges();
  }

  toggleProperty(property: 'isSpecificationCollapsed' | 'isDimensionsCollapsed'): void {
    this[property] = !this[property];
  }

  toggleShowMore(): void {
    this.isShowMore = !this.isShowMore;
  }

  getAttributeLabel(attrCode: string): string {
    return this.attributeService.getAttributeLabel(attrCode);
  }

  get isShowDimensionsBlock(): boolean {
    const { width, height, depth, weight, length } = this.product;
    return Boolean(width || height || depth || weight || length);
  }

  private isDescriptionOverflowing(): boolean {
    if (!this.descriptionRef) {
      return false;
    }

    const { nativeElement: description } = this.descriptionRef;

    return description.offsetHeight < description.scrollHeight;
  }
}
